export default __webpack_public_path__ + "static/media/implant.4aaf1871.svg";